import { render } from "./LegacyFlowSteps.vue?vue&type=template&id=2cf547f0"
import script from "./LegacyFlowSteps.vue?vue&type=script&lang=js"
export * from "./LegacyFlowSteps.vue?vue&type=script&lang=js"
script.render = render

export default script